import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteWebsite {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Websites/DeleteSubscription.js